module Meevo.Components.Controls.SmartMover {
    import Membership = Model.Membership;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class YMMembershipsCollection extends SmartMoverApiCollection<Membership> implements IApiCollection<Membership> {

        get url() {
            return 'Membership';
        }

        constructor(connectedModel: ModelValueType[], items: Membership[] = [], options: ICollectionOptions<Membership> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                objectStateEnumList: [ObjectStateEnum.Active, ObjectStateEnum.Inactive],
                includeActive: true,
                includeInactive: true
            });
        }
    }
}
